import { useTranslation } from "react-i18next";
import { ApiTask, ApiTaskKanbanStatus, ApiTaskStatus } from "src/api/types";
import Tag, { TagSize } from "src/components/Tag";

const colors = {
	completed: {
		bg: "green",
		border: "green-500",
		color: "white",
	},
	matched: {
		bg: "primary",
		color: "white",
	},
	expired: {
		bg: "red",
		color: "white",
	},
	cancelled: {
		bg: "red",
		color: "white",
	},
	TODO: {
		bg: "dark-200",
		color: "dark",
	},
	IN_PROGRESS: {
		bg: "blue-200",
		color: "blue",
	},
	COMPLETED: {
		bg: "green-200",
		color: "green",
	},
} as any;

interface TaskStatusProps {
	task?: ApiTask;
	status: ApiTaskStatus | ApiTaskKanbanStatus;
	size: TagSize;
}

const TaskStatus = ({ status, size }: TaskStatusProps) => {
	const { t } = useTranslation("tasks", {
		keyPrefix: "status",
	});

	const border = colors[status]?.border || undefined;
	const bg = colors[status]?.bg || "gray";
	const color = colors[status]?.color || undefined;

	return (
		<Tag
			className={`bg-${bg} text-${color} ${
				border ? ` border-${border}` : ""
			} font-bold`}
			{...{ size }}
		>
			{t(status || "open")}
		</Tag>
	);
};

TaskStatus.defaultProps = {
	size: "default",
};

export default TaskStatus;
